import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../helpers/formatters';

function AmountWithFee({
    amount,
    fee,
    discount = 0,
}: {
    amount: number;
    fee: number;
    discount?: number;
}) {
    const { t } = useTranslation();
    if (!fee && !discount) return null;
    return (
        <>
            {discount > 0 && (
                <span style={{ display: 'block', fontSize: '0.75em', color: '#2e7d32' }}>
                    -{formatCurrency(discount / 100)} {t('email.parts.cart.discountLabel')}
                </span>
            )}
            {!!fee && (
                <span style={{ display: 'block', fontSize: '0.75em', color: '#555' }}>
                    {fee > 0 ? '+ ' : ''}
                    {formatCurrency(fee / 100)} {t('transactions.fee')}
                </span>
            )}
            <span style={{ display: 'block', fontSize: '0.8em', fontWeight: 600 }}>
                {t('transactions.columns.total')}: {formatCurrency((amount - discount + fee) / 100)}
            </span>
        </>
    );
}

export default AmountWithFee;
